











import { Component, Prop, Vue } from 'vue-property-decorator';
import { default as ColourPicker } from '@/shared/services/color';
@Component
export default class Banner extends Vue {
	@Prop() public showOverlay: boolean;
	@Prop({default: 'warning'}) public type: 'warning' | 'info';

	public getContrastingColour() {
		let bgColour = '#91B2ff';
		if (this.type === 'warning') {
			bgColour = '#E6C300';
		}
		return ColourPicker.getContrastingColour(bgColour);
	}
}
